<!-- 集合很多页面的查看更多组件 -->
<template>
  <div
    :class="type === 'inOut' ? 'person_in' : type === 'active' ? 'ativity_more' : type === 'info' ? 'info_more' : ''"
    class="check"
  >
    <div class="more">
      <div class="record">
        <div class="title_box">
          <div class="title">{{ moreTitle }} > {{ $t('SeeMore') }}</div>
        </div>
        <div class="check_more" @click="backLast">{{ $t('returnM') }}></div>
      </div>
      <AlarmStatu v-if="type === '3dbar'" class="alarm_statu" :traceData="echartData" :more="more"></AlarmStatu>
      <PersonMedia v-if="type === 'bar'" :barData="echartData" :more="more" class="alarm_statu"></PersonMedia>
      <RaiseHatAlarm v-if="type === 'cone'" :barWidth="barWidth" :more="more" :hatList="echartData"></RaiseHatAlarm>
      <!-- 对讲 -->
      <div class="info_line" v-if="type === 'info'">
        <IntercomRecord :more="more" :currenNode="currenNode"></IntercomRecord>
      </div>
      <div v-if="type === 'table'">
        <PersonnelAccess :personalMore="personalMore" :setMore="setMore"></PersonnelAccess>
      </div>
      <!-- 人员进出 -->
      <div v-if="type === 'inOut'" class="hit_more">
        <PersonInOut :inOutHistory="inOutHistory" :currenNode="currenNode"></PersonInOut>
      </div>
      <div v-if="type === 'active'" class="active_box">
        <PersonAtivity :currenNode="currenNode" :personHas="activeMore"></PersonAtivity>
      </div>
      <!-- 设备剩余电量 -->
      <div v-if="type === 'device'" class="device_more">
        <DeviceDynamic :more="more" :currenNode="currenNode" :moreTitle="moreTitle"></DeviceDynamic>
      </div>
      <div v-if="type === 'static'" class="hit_more">
        <personStatic :more="more" :currenNode="currenNode" :moreTitle="moreTitle" :StaticSearchTime="StaticSearchTime"></personStatic>
      </div>
    </div>
  </div>
</template>

<script>
import AlarmStatu from '@/views/new-home/AlarmStatu.vue'
import PersonMedia from '@/views/new-person/PersonMedia.vue'
import RaiseHatAlarm from '@/views/new-warn/RaiseHatAlarm.vue'
import PersonnelAccess from '@/views/new-home/PersonnelAccess.vue'
import PersonInOut from '@/views/new-person/PersonInOut.vue'
import PersonAtivity from '@/views/new-person/PersonAtivity.vue'
import DeviceDynamic from '@/views/new-device/DeviceDynamic.vue'
import IntercomRecord from '@/views/new-home/IntercomRecord.vue'
import personStatic from '@/views/new-person/PersonAttendanceStatic.vue'
export default {
  props: {
    moreTitle: {
      type: String,
    },
    echartData: {
      type: Object / Array,
    },
    type: {
      type: String,
    },
    currenNode: {
      type: Object / Array,
    },
    StaticSearchTime: {
      type: String,
    },
  },
  data() {
    return {
      barWidth: 20,
      more: true,
      dataList: [],
      personalMore: true,
      setMore: true,
      // 人员进出记录
      inOutHistory: true,
      activeMore: true,
    }
  },
  components: {
    AlarmStatu,
    PersonMedia,
    RaiseHatAlarm,
    PersonnelAccess,
    PersonInOut,
    PersonAtivity,
    DeviceDynamic,
    IntercomRecord,
    personStatic
  },
  methods: {
    backLast() {
      // 返回触发相关事件
      this.$emit('backHome')
    },
  },
  watch: {
    echartData: {
      handler(newval, oldval) {},
      deep: true,
    },
    moreTitle: {
      immediate: true,
      handler(val) {},
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.check
  width: 100%
  height: 100%
  position: relative
  pointer-events: auto
  .more
    position: absolute
    top 50%
    left: 50%
    transform: translate(-50%,-50%)
    width: 100%
    height: 100%
    min-height: 460px;/*no*/
    background: #fff;
    border: 1px solid;
    box-shadow: 0px 3px 30px 0px rgba(0, 120, 255, 0.4)
    pointer-events: auto
    .alarm_statu
      width: 100%
      height 95%
    .record
      position: relative
      .check_more
        position: absolute
        right: 15px
        top 50%
        transform: translate(0,-50%)
        text-align: center
        line-height: 28px
        padding: 0 7px
        border: 1px solid rgba(#5994C6,1)
        border-radius: 2px
        font-weight: bold
        color: #5994C6
        font-size: 14px
        border-radius: 4px;
        cursor pointer
      .title_box
        background url('~@/icon/new-common/more_head.png')no-repeat
        background-size: 100% 100%;
        -webkit-background-size: 100% 100%;
        .title
          width 100%
          height 40px
          line-height 40px
          padding-left 60px
          font-size: 20px;
          color #0E65DD
          font-weight: bold
  .info_line
    width: 100%
    height: calc(100% - 40px)
    margin: 0 auto 0
    ul
      width: 100%
      li
        width: 100%
        line-height: 30px
        no-wrap()
        .bell_icon
          width 16px
          height 16px
          margin-right 10px
        .news_name
          margin-right 10px
        .news_time
          margin-left 10px
    // background: #333
  .active_box
    width: 100%
    height: calc(100% - 50px)
    .test
      background: #ccc
      pointer-events: auto
  .device_more
    height: calc(100% - 50px)
    display: flex
    justify-content: center
  .hit_more
    height: calc(100% - 40px)
    margin-top: 20px
.person_in
    width: 100%
    height: 100%
    margin: 0 auto
.ativity_more
  .more
    width: 100%
    height: 100%
.info_more
  width: 100%
  height: 100%
  margin: 0 auto
.theme-dark
  .more
    background: #001143
    .record
      .check_more
        border 1px solid rgba(#00E4FF, 1)
        color #00E4FF
      .title_box
        background url('~@/icon/new-common/icmore_head.png')no-repeat
        .title
          color #00E4FF
</style>
